import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: { id: 'Timeline CSJ', defaultMessage: 'Timeline CSJ' },
  episodes: { id: 'Timeline episodes', defaultMessage: 'Episodis' },
  image: { id: 'Image', defaultMessage: 'Imatge' },
  year: { id: 'Year', defaultMessage: 'Any' },
  text: { id: 'Episode text', defaultMessage: 'Text' },
});

const EpisodeSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.episodes),
  fieldsets: [
    { id: 'default', title: 'Default', fields: ['image', 'year', 'text'] },
  ],
  properties: {
    image: {
      title: intl.formatMessage(messages.image),
      widget: 'object_browser',
      mode: 'image',
      return: 'single',
      selectableTypes: ['Image'],
      initialPath: 'recursos',
      selectedItemAttrs: ['@type', 'title', 'image_field', 'image_scales'],
    },
    year: { title: intl.formatMessage(messages.year) },
    text: { title: intl.formatMessage(messages.text), widget: 'textarea' },
  },
  required: ['year', 'text'],
});

export const TimelineSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.title),
  fieldsets: [{ id: 'default', title: 'Default', fields: ['episodes'] }],
  properties: {
    episodes: {
      title: intl.formatMessage(messages.episodes),
      widget: 'object_list',
      schema: EpisodeSchema({ intl }),
    },
  },
  required: [],
});
